module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('op-header'), _vm._v(" "), _c('div', {
    staticClass: "content register22 content-min-height"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "bar"
  }, [_c('li', {
    class: _vm.registerType == 'person' ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.switchRegisterType('person')
      }
    }
  }, [_vm._v("\n          个人注册\n        ")]), _vm._v(" "), _c('li', {
    class: _vm.registerType == 'enterprise' ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.switchRegisterType('enterprise')
      }
    }
  }, [_vm._v("\n          企业注册\n        ")])])]), _vm._v(" "), (_vm.registerType == 'person') ? _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.personInfo,
      "rules": _vm.personRules,
      "label-width": "100px",
      "size": "small",
      "name": "personForm"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机账户",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入您的手机号码",
      "name": "mobile"
    },
    model: {
      value: (_vm.personInfo.mobile),
      callback: function($$v) {
        _vm.$set(_vm.personInfo, "mobile", $$v)
      },
      expression: "personInfo.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "由6-14数字、字母组成",
      "name": "password"
    },
    model: {
      value: (_vm.personInfo.password),
      callback: function($$v) {
        _vm.$set(_vm.personInfo, "password", $$v)
      },
      expression: "personInfo.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机验证",
      "prop": "authCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入您的手机验证码",
      "name": "authCode"
    },
    model: {
      value: (_vm.personInfo.authCode),
      callback: function($$v) {
        _vm.$set(_vm.personInfo, "authCode", $$v)
      },
      expression: "personInfo.authCode"
    }
  }, [_c('aliCaptcha', {
    attrs: {
      "slot": "append",
      "handCallback": _vm.countdownLe,
      "verify": _vm.newSend,
      "verifyType": 2,
      "mobileOrEmail": _vm.personInfo.mobile
    },
    slot: "append"
  }, [_c('el-button', {
    staticStyle: {
      "width": "109px",
      "background-color": "#023D92",
      "color": "#fff",
      "padding": "12px 0"
    },
    attrs: {
      "disabled": _vm.downdis
    }
  }, [_vm._v(_vm._s(_vm.downText))])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.agreement),
      callback: function($$v) {
        _vm.agreement = $$v
      },
      expression: "agreement"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("我已阅读")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.showAgreementDiv
    }
  }, [_vm._v("《电子数据保全服务协议》")])])], 1), _vm._v(" "), _c('el-form-item', [(_vm.agreement) ? _c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.personRegister
    }
  }, [_vm._v("同意协议并注册")]) : _c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "info",
      "disabled": ""
    }
  }, [_vm._v("同意协议并注册")])], 1)], 1)], 1) : (_vm.registerType == 'enterprise') ? _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.enterpriseInfo,
      "rules": _vm.enterpriseRules,
      "label-width": "100px",
      "size": "small",
      "name": "enterpriseForm"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业名称",
      "prop": "companyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入企业名称",
      "name": "companyName"
    },
    model: {
      value: (_vm.enterpriseInfo.companyName),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfo, "companyName", $$v)
      },
      expression: "enterpriseInfo.companyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱账号",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入您的邮箱",
      "name": "email"
    },
    model: {
      value: (_vm.enterpriseInfo.email),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfo, "email", $$v)
      },
      expression: "enterpriseInfo.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "联系方式",
      "prop": "linkMobile"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入您的联系方式",
      "name": "linkMobile"
    },
    model: {
      value: (_vm.enterpriseInfo.linkMobile),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfo, "linkMobile", $$v)
      },
      expression: "enterpriseInfo.linkMobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录密码",
      "prop": "ePassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "由6-14数字、字母组成",
      "name": "password"
    },
    model: {
      value: (_vm.enterpriseInfo.ePassword),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfo, "ePassword", $$v)
      },
      expression: "enterpriseInfo.ePassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图形验证",
      "prop": "eRandomCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入图形验证码",
      "name": "eRandomCode"
    },
    model: {
      value: (_vm.enterpriseInfo.eRandomCode),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfo, "eRandomCode", $$v)
      },
      expression: "enterpriseInfo.eRandomCode"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": _vm.eImgCodeSrc
    },
    on: {
      "click": _vm.getRandomCode
    }
  })])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.agreement),
      callback: function($$v) {
        _vm.agreement = $$v
      },
      expression: "agreement"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("我已阅读")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.showAgreementDiv
    }
  }, [_vm._v("《电子数据保全服务协议》")])])], 1), _vm._v(" "), _c('el-form-item', [(_vm.agreement) ? _c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.enterpriseRegister
    }
  }, [_vm._v("同意协议并注册")]) : _c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "info",
      "disabled": ""
    }
  }, [_vm._v("同意协议并注册")])], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo_black.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none",
      "width": "800px",
      "margin": "0 auto",
      "padding": "30px 60px",
      "font": "12px 'Microsoft YaHei', Arial",
      "line-height": "24px",
      "color": "#5B5B5B"
    },
    attrs: {
      "id": "agreementDiv"
    }
  }, [_c('p', [_vm._v("\n      本协议是您（以下也称\"服务使用人\"）与易保全（电子数据保全中心）平台之间关于电子数据保全各项服务的协议。本协议内容包括协议正文、易保全（电子数据保全中心）当前以及今后随时发布的关于电子数据保全服务的各种规范、规则等。本协议中的\"保全中心平台\"是指由易保全网络科技有限公司提供的电子数据保全综合服务平台，域名为www.ebaoquan.org。\n      我们在此特别提醒，在使用保全中心平台上提供的各项服务前，请您务必事先认真阅读本协议所有内容，协议中包含了保全中心平台的免责条款以及对用户的权利限制条款。请您审阅并对是否接受所有服务条款作出明确意思表示，若您承诺接受本协议则须遵守本协议相关条款；若您不接受则应立即停止注册程序或停止使用易保全（电子数据保全中心）的相关服务。若您有不明白之处，请务必向保全中心工作人员垂询，中心工作人员将向您作详细的说明和解释。\n      易保全（电子数据保全中心）有权根据需要制订、修改本协议及各种规范、规则等，并在其平台上进行公告。变更后的协议和规范、规则一经公告，立即生效，您可以随时登陆保全中心平台查阅相关信息。如果您不同意相关变更，应当立即停止使用电子数据保全的相关服务。如您继续使用电子数据保全的相关服务，即视为您接受经修订的协议和规范、规则。\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-bottom": "10px",
      "font-family": "'Microsoft YaHei'"
    }
  }, [_vm._v("一、产品保护条款")]), _vm._v(" "), _c('p', [_vm._v("\n      1、易保全（电子数据保全中心）所提供的服务涉及的文字表述及组合、图片、网页设计等，以及各软件、技术均属电子数据保全中心所有，受《中华人民共和国著作权法》和其他知识产权法等相关法律法规的保护。易保全（电子数据保全中心）保留追究任何第三方侵权使用本网站成果的权力。\n      2、您应正当使用电子数据保全中心的各项服务并承担一定的意外风险。在使用保全服务过程中，您不得从事任何影响网络正常运作的行为，包括借助装置、软件或例行程序进行干预等易保全（电子数据保全中心）在任何情况下不对因服务使用人不正当使用、有意或恶意利用服务的缺陷或其他特殊的、意外的原因（或行为）造成的非直接或间接的损失承担赔偿责任。\n      3、由于易保全（电子数据保全中心）的各项服务涉及到互联网服务、本地操作环境、网络各环节等因素的影响，因此服务可能因计算机病毒或黑客攻击、网络提供商提供的服务差异化或出现意外状况、用户所在位置以及其他任何技术、互联网络、通信线路等原因出现异常或其他不能满足用户要求的风险。对非保全中心平台造成的以上风险，易保全（电子数据保全中心）不承担任何责任。\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-bottom": "10px",
      "font-family": "'Microsoft YaHei'"
    }
  }, [_vm._v("二、新用户注册")]), _vm._v(" "), _c('p', [_vm._v("\n      1、（1）在您进行易保全（电子数据保全中心）注册或实际使用保全中心平台提供的服务时，您应具备完全民事权利能力和完全民事行为。若您不具备前述主体资格，易保全（电子数据保全中心）保留对您的账号采取冻结使用乃至注销您的账户等权利。\n      （2）涉及无民事行为能力人、限制民事行为能力人的保全服务，建议以其监护人的名义申请保全中心平台并获取保全中心提供的服务。\n      2、在您注册时应填写真实有效的身份信息，注册时请务必使用您本人的真实信息，并确保注册时所需信息填写准确、完全。虚假身份信息会导致无法进行身份认证。身份认证是相关司法机构为您出具司法文书的前提。建议您在注册后尽快进行基本或者高级身份认证，方便保全中心出具保全证书以及日后申请出具相关司法文书，同时也可获得平台其他更多服务。\n      3、请您务必认真阅读本协议，在完全接受本协议条款后，方可注册成保全中心平台的用户。一旦注册成为我们的用户，即表示您同意接受协议各项条款的约束，包括接受保全中心平台今后随时对服务条款所做的任何修改。届时您不应以未阅读本协议或不理解本协议的内容为由，主张协议无效或要求撤销协议。\n      4、在你注册为保全中心平台用户后，应牢记您的用户名及登录密码，妥善保管登录密码，采取积极的保密措施保护您（注册人）的上述信息及资料免受窃取。用户名及登录密码将作为保全中心平台确认您的身份的依据，您应对您的用户名和密码的安全，以及通过您的用户名和密码实施的行为负责。因用户自己遗失本保全中心平台账号密码或自行将保全文件发布到其他网络平台而造成保全文件内容泄露的，由用户自行承担责任，易保全（电子数据保全中心）对此不承担任何责任。\n      5、保全中心平台会对已上传的作品加强技术保护。所有上传的作品经三层加密，保存在自建的云存储环境，以确保每位上传作品用户原始信息的安全。易保全（电子数据保全中心）非经您本人（服务使用人）许可，不会将您的信息及保全内容泄露给他人。\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-bottom": "10px",
      "font-family": "'Microsoft YaHei'"
    }
  }, [_vm._v("三、保全中心平台服务使用规范")]), _vm._v(" "), _c('p', [_vm._v("\n      1、（1）您必须合法地使用保全中心平台的各项服务，在使用保全中心平台上的各项服务时，您应当对通过您的账号所实施的一切行为负责。\n      （2）您不得利用保全中心平台的各项服务及产品从事非法活动，包括且不限于利用本站传播、存取非法、违反公序良俗的内容，不可采用网络、电脑技术等各种手段，制造虚假证据，并利用易保全（电子数据保全中心）服务以获取个人利益。\n      （3）您不得上传违反中华人民共和国相关法律法规的规定的文件至保全中心平台。禁止上传的材料类型包括：（1）包含侵犯他人著作权、商标权、专利权、名誉权、隐私权、物权、商业秘密等合法权益内容信息的材料。（2）含有危害国家安全、损害国家荣誉和利益、损害社会公共利益、泄露国家机密、违反国家民族宗教法律政策、破坏社会公共秩序、淫秽色情、暴力、赌博、恐怖主义；教唆犯罪；侮辱诽谤他人；侵犯他人个人隐私等内容信息的材料。（3）含有政治因素作品或者国家规定的其他需获得行政许可的作品。（4）其他违反法律法规、有损社会公序良俗的材料。\n      （4）电子数据保全中心是为用户提供保全文件保护的第三方服务商。保全中心平台内容的真实性由您本人负责，涉及到您单方意思表示的，请慎重考虑后作出。电子数据保全中心不做审查、判断保全文件是否侵权的承诺，也不对用户所发布信息的合法性、真实性及其品质等进行审查。若发现平台上有违法侵权（具体违反前述第（3）条）的保全文件，欢迎举报。保全中心会及时对该文件做出下线处理。\n      （5）经发现或接到举报，或有合理理由怀疑您的账号存在违法情况及其他违反本协议的行为时，保全中心平台有权对你的账号采取限制措施，并限期要求您向保全中心平台公开可疑内容，限期进行整改，直至删除您的资料或应公安机关、司法机关的要求公开（公示）您的信息及违法内容、注销您的账号。保全中心平台有权对您是否存在上述违法情况、违反本协议的行为单方作出认定，采取上述各项措施，无须征得您的同意或提前通知予您。\n      2、（1）对于您的行为（包括非法的或正常使用保全中心服务的行为）对任意第三方造成损害的，您均应以自己的名义独立承担所有的法律责任，并应确保免于对保全中心造成损失。\n      （2）如保全中心平台因您的行为（包括非法的或正常使用保全中心服务服务的行为）遭受任何损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，您应当赔偿保全中心平台因此造成的损失及（或）发生的一切费用。\n      3、（1）您如果发现或怀疑您的账号被盗用，或存在其他安全问题时，您应当立即以有效方式通知保全中心平台，并可以要求保全中心平台采取一定的措施，且应配合保全中心平台为采取措施而实施的调查、要求补证、身份核实等工作。若您所提供的资料未能使保全中心平台完全确信您是账号的注册人时，保全中心平台可能不会应您的要求采取措施。\n      （2）保全中心平台不对您账号使用的安全问题承担任何责任。但您若冒用他人名义要求保全中心平台对账号采取措施导致侵权、致他人损失的，您应承担一切责任。\n      4、因您填写、预留的联系方式有误，导致保全中心平台无法与您取得联系的，因此产生的后果由您自行负责，包括您使用服务过程中产生任何损失或增加费用等。\n      5、（1）保全中心平台提供的保全、合同保、日志保等服务均有一定的针对性，保全方式因服务内容不同而不尽相同。在使用前务必认真了解各项服务内容。\n      （2）涉及交叉使用保全中心平台提供的各项服务的，如有不清楚之处，务必联系工作人员，由工作人员对您进行指导。\n      6、在完成保全之后，务必对保全的证书进行浏览、查看、确认，以免在因服务限制、错用服务等各项原因导致保全证书不能及时生成的情况下，及时采取补救措施。\n      7、保全中心平台提供的保全服务均为自助型服务，请勿向客服人员提出参与保全的要求。\n      8、为确保保全服务的网络安全，防止信息泄露，请您不要在公用电脑上进行保全服务。\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-bottom": "10px",
      "font-family": "'Microsoft YaHei'"
    }
  }, [_vm._v("四、用户的终止与注销")]), _vm._v(" "), _c('p', [_vm._v("\n      1、出现以下情况时，保全中心平台有权直接以注销用户的方式终止本协议:\n      （1）您不是具备完全民事权利能力和完全民事行为能力的自然人；\n      （2）您注册信息中的主要内容不真实、不准确、不及时、不完整，或注册信息包含非法的、可能侵犯他人合法权益的、违背社会公序良俗的内容，并经保全中心平台提示后未在限期内进行修改的；\n      （3）一经发现您利用保全中心平台从事违法的、侵犯他人合法权益、违背社会公序良俗的行为，且经保全中心平台提示后未在限期内改正的；\n      （4）本协议（含规则）变更时，您明示并通知保全中心平台不愿接受新的服务协议的；\n      （5）其它保全中心平台认为应当终止服务的情况。\n      2、您与保全中心平台的协议关系终止后，您在使用保全中心服务平台期间存在违法行为或违反本协议或规则的行为的，保全中心仍可依据本协议向您要求承担法律责任。\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-3f588560!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/modules/register/App.vue
// module id = 1090
// module chunks = 40